(function () {
  'use strict';

  angular.module("lif.filters").filter("mainlink", mainLinkFilter);
  mainLinkFilter.$inject = ['$location'];

  function mainLinkFilter($location) {
    return function (items) {
      var filtered = [];
      var absUrl = $location.absUrl();

      for (var i = 0; i < items.length; i++) {
        var item = items[i];

        if (item.Url !== undefined) {
          var urlWithoutSlashes = item.Url.split("/").join("");
          var isOnPage = absUrl.indexOf(urlWithoutSlashes) > -1;

          if (!isOnPage) {
            filtered.push(item);
          }
        }
      }

      return filtered;
    };
  }

  ;
})();